module.exports = __webpack_public_path__ + "img/cpzz4@2x.1b8728c5.png";